export type BestellnummerQuelle = "regel" | "manuell" | null | undefined;

export function classifyBestellnummerQuelle(
  value: string | null | undefined,
  regelWert: string | null | undefined,
  storedQuelle?: BestellnummerQuelle,
): "regel" | "manuell" | null {
  const current = String(value || "").trim();
  const regel = String(regelWert || "").trim();
  if (!current) return null;
  if (regel && current === regel) return "regel";
  if (storedQuelle === "regel" && !regel) return "regel";
  return "manuell";
}

export function bestellnummerQuelleLabel(quelle: BestellnummerQuelle): string | null {
  if (quelle === "regel") return "Kundenregel";
  if (quelle === "manuell") return "Manuell";
  return null;
}
